export type CourseDesign = 'tiles' | 'list' | 'navigator'

export const normalizeCourseDesign = (value: unknown): CourseDesign | null =>
  value === 'tiles' || value === 'list' || value === 'navigator' ? value : null

export const appendCourseDesign = (data: FormData, value: unknown, tariffsOnly = false) => {
  // Missing/unknown fields must not reset a design saved by another client.
  if (!tariffsOnly && (value === null || normalizeCourseDesign(value))) {
    data.append('course_design', value === null ? '' : String(value))
  }
}
